export const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)')?.matches === true;

// scrollIntoView suave, mas instantâneo com "reduzir movimento".
export const scrollToCenter = (element) =>
  element?.scrollIntoView({
    behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    block: 'center',
  });

// Tempo da saída do modal/colapso: use antes de mudar o que está atrás (sequência modal -> badge).
export const waitForExit = () =>
  new Promise((resolve) =>
    setTimeout(resolve, prefersReducedMotion() ? 0 : 170),
  );
